    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">


                        <el-form-item label="用户:">
                            <el-select v-model="table.where.user_id" filterable placeholder="请选择">
                                <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="兑奖状态:">
                            <el-input-number v-model="table.where.rec_exch_status" placeholder="请输入兑奖状态"
                                :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="中奖等级:">
                            <el-input-number v-model="table.where.rec_grade" placeholder="请输入中奖等级" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="奖品名称:">
                            <el-input v-model="table.where.rec_name" placeholder="请输入奖品名称" clearable />
                        </el-form-item>

                        <el-form-item label="奖品图片:">
                            <el-input v-model="table.where.rec_src" placeholder="请输入奖品图片" clearable />
                        </el-form-item>

                        <el-form-item label="中奖时间:">
                            <el-date-picker v-model="table.where.rec_time" type="datetimerange" start-placeholder="开始日期"
                                end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="截止兑奖时间:">
                            <el-date-picker v-model="table.where.rec_over_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="收货人:">
                            <el-input v-model="table.where.rec_user_name" placeholder="请输入收货人" clearable />
                        </el-form-item>

                        <el-form-item label="收货人电话:">
                            <el-input-number v-model="table.where.rec_phone" placeholder="请输入收货人电话" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="收货地址:">
                            <el-input v-model="table.where.rec_address" placeholder="请输入收货地址" clearable />
                        </el-form-item>

                        <el-form-item label="门牌号:">
                            <el-input v-model="table.where.rec_door_num" placeholder="请输入门牌号" clearable />
                        </el-form-item>

                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon"
                                v-if="permission.includes('sys:activityturntablerecord:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    
                   
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                        
                        <el-button :type="table.where.rec_exch_status == 3?'primary':'info'" size="small"  @click="(table.where.rec_exch_status = 3)&&$refs.table.reload()">待兑换</el-button>
                        <el-button :type="table.where.rec_exch_status == 4?'primary':'info'" size="small"  @click="(table.where.rec_exch_status = 4)&&$refs.table.reload()">待付款</el-button>
                        <el-button :type="table.where.rec_exch_status == 5?'primary':'info'" size="small" @click="(table.where.rec_exch_status = 5)&&$refs.table.reload()">待发货</el-button>
                        <el-button :type="table.where.rec_exch_status == 6?'primary':'info'" size="small" @click="(table.where.rec_exch_status = 6)&&$refs.table.reload()">已完成</el-button>
                        <el-button :type="table.where.rec_exch_status==''?'primary':'info'" size="small" @click="(table.where.rec_exch_status = '')&&$refs.table.reload()">全部</el-button>
                       
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />
                        <el-table-column prop="user_id" label="用户" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.user_id_info"
                                    :key="index">{{item.nick_name+item.phone}}</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="rec_exch_status" label="兑奖状态" sortable="custom" show-overflow-tooltip
                            min-width="120"  >
                            <template slot-scope="{row}">
                                <el-tag v-if="row.rec_exch_status == 3">未兑奖</el-tag>
                                <el-tag v-if="row.rec_exch_status == 4">待支付</el-tag>
                                <el-tag v-if="row.rec_exch_status == 5">待发货</el-tag>
                                <el-tag v-if="row.rec_exch_status == 6">已完成</el-tag>
                                <el-tag v-if="row.rec_exch_status == 7">已过期</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="rec_grade" label="中奖等级" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="rec_name" label="奖品名称" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="rec_img" label="奖品图片" sortable="custom" show-overflow-tooltip
                            min-width="120">
                             <template slot-scope="{row}">
                                <el-image
                                        style="width: 50px; height: 50px"
                                        :src="row.rec_img"
                                        :preview-src-list="[row.rec_img]">
                                </el-image>
                            </template>
                            </el-table-column>
                        <el-table-column prop="rec_time" label="中奖时间" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="rec_over_time" label="截止兑奖时间" sortable="custom" show-overflow-tooltip
                            min-width="120" />
 <el-table-column prop="user_id" label="用户" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag>{{row.rec_user_name+row.rec_phone}}</el-tag>
                                <br>
                                <el-tag>{{row.rec_address+row.rec_door_num}}</el-tag>
                            </template>
                        </el-table-column>
                       
                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="deliverGoodsShow(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:activityturntablerecord:edit')">发货</el-link>
                                    <el-link @click="wuliu(row)" icon="el-icon-box" type="danger" :underline="false"
                                        v-if="permission.includes('sys:storegoodsorder:edit') && row.status == 3">物流详情</el-link>
                                <!-- <el-popconfirm title="确定要删除此中奖记录吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:activityturntablerecord:delete')">删除</el-link>
                                </el-popconfirm> -->
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改中奖记录':'添加中奖记录'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">


                    <el-form-item label="用户:" prop="user_id">
                        <el-select v-model="editForm.user_id" filterable placeholder="请选择">
                            <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                :value="item.id">
                            </el-option>
                        </el-select>

                    </el-form-item>

                    <el-form-item label="兑奖状态:" prop="rec_exch_status">
                        <el-input-number v-model="editForm.rec_exch_status" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入兑奖状态" clearable />
                    </el-form-item>

                    <el-form-item label="中奖等级:" prop="rec_grade">
                        <el-input-number v-model="editForm.rec_grade" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入中奖等级" clearable />
                    </el-form-item>

                    <el-form-item label="奖品名称:" prop="rec_name">
                        <el-input v-model="editForm.rec_name" placeholder="请输入奖品名称" clearable />
                    </el-form-item>

                    <el-form-item label="奖品图片:" prop="rec_src">
                        <el-input v-model="editForm.rec_src" placeholder="请输入奖品图片" clearable />
                    </el-form-item>


                    <el-form-item label="中奖时间:" prop="rec_time">
                        <el-date-picker v-model="editForm.rec_time" type="datetime" placeholder="选择中奖时间" size="small"
                            value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>

                    </el-form-item>


                    <el-form-item label="截止兑奖时间:" prop="rec_over_time">
                        <el-date-picker v-model="editForm.rec_over_time" type="datetime" placeholder="选择截止兑奖时间"
                            size="small" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>

                    </el-form-item>

                    <el-form-item label="收货人:" prop="rec_user_name">
                        <el-input v-model="editForm.rec_user_name" placeholder="请输入收货人" clearable />
                    </el-form-item>

                    <!-- <el-form-item label="收货人电话:" prop="rec_phone">
                        <el-input-number v-model="editForm.rec_phone" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入收货人电话" clearable />
                    </el-form-item>

                    <el-form-item label="收货地址:" prop="rec_address">
                        <el-input v-model="editForm.rec_address" placeholder="请输入收货地址" clearable />
                    </el-form-item>

                    <el-form-item label="门牌号:" prop="rec_door_num">
                        <el-input v-model="editForm.rec_door_num" placeholder="请输入门牌号" clearable />
                    </el-form-item> -->


                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
            <el-dialog title="物流信息" :visible.sync="wuliushowEdit" width="800px" :destroy-on-close="true" :lock-scroll="false"
                @close="closeDialog" :close-on-click-modal="false">
                <template>
                   <el-timeline-item v-for="(item,index) in wuliu_info.path_item_list" :key="index" :timestamp="item.action_time" placement="top">
                        <el-card>
                          <h4 v-if="item.action_type == 100001">揽件阶段-揽件成功</h4>
                          <h4 v-if="item.action_type == 100002">揽件阶段-揽件失败</h4>
                          <h4 v-if="item.action_type == 100003">揽件阶段-分配业务员</h4>
                          <h4 v-if="item.action_type == 200001">运输阶段-更新运输轨迹</h4>
                          <h4 v-if="item.action_type == 300002">派送阶段-开始派送</h4>
                          <h4 v-if="item.action_type == 300003">派送阶段-签收成功</h4>
                          <h4 v-if="item.action_type == 300004">派送阶段-签收失败</h4>
                          <h4 v-if="item.action_type == 400001">异常阶段-订单取消</h4>
                          <h4 v-if="item.action_type == 400002">异常阶段-订单滞留</h4>
                          <p>{{item.action_msg}}</p>
                        </el-card>
                      </el-timeline-item>
                </template>
                   
                <div slot="footer">
                    <el-button @click="wuliushowEdit=false">关闭</el-button>
                </div>
            </el-dialog>
            <el-dialog title="快递信息" :visible.sync="fahuoShowEdit" width="800px" :destroy-on-close="true" :lock-scroll="false"
                @close="closeDialog" :close-on-click-modal="false">
                <template>
                    <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                   <el-form-item label="物流信息:" prop="delivery_id">
                       <el-select v-model="editFormfahuo.delivery_id" filterable placeholder="请选择物流信息">
                           <el-option v-for="(item,index) in logistics_fare_class" :key="index" :label="item.title" :value="item.id"></el-option>
                       </el-select>
                   </el-form-item>
                   </el-form>
                </template>
                   
                <div slot="footer">
                    <el-button @click="fahuoShowEdit=false">取消</el-button>
                    <el-button type="primary" @click="deliverGoods">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";


        export default {
            name: "SysActivityTurntableRecord",
            components: {},
            data() {
                return {
                    editFormfahuo:{
                        delivery_id:'',
                    },
                    fahuoShowEdit:false,
                    wuliu_info:{},
                    wuliushowEdit:false,
                    logistics_fare_class:[],
                    table: {
                        url: '/activity/ActivityTurntableRecord/index',
                        where: {
                            rec_mode:1,
                            rec_exch_status:5,
                        }
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {}, // 表单数据
                    editFormTemp: {},
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    user_openinfo_list: [],
                    editRules: { // 表单验证规则

                        user_id: [{
                            required: true,
                            message: '请选择用户',
                            trigger: 'blur'
                        }],


                        rec_exch_status: [{
                            required: true,
                            message: '请输入兑奖状态',
                            trigger: 'blur'
                        }],


                        rec_grade: [{
                            required: true,
                            message: '请输入中奖等级',
                            trigger: 'blur'
                        }],


                        rec_name: [{
                            required: true,
                            message: '请输入奖品名称',
                            trigger: 'blur'
                        }],


                        rec_src: [{
                            required: true,
                            message: '请输入奖品图片',
                            trigger: 'blur'
                        }],


                        rec_time: [{
                            required: true,
                            message: '请选择中奖时间',
                            trigger: 'blur'
                        }],


                        rec_over_time: [{
                            required: true,
                            message: '请选择截止兑奖时间',
                            trigger: 'blur'
                        }],


                        rec_user_name: [{
                            required: true,
                            message: '请输入收货人',
                            trigger: 'blur'
                        }],


                        rec_phone: [{
                            required: true,
                            message: '请输入收货人电话',
                            trigger: 'blur'
                        }],


                        rec_address: [{
                            required: true,
                            message: '请输入收货地址',
                            trigger: 'blur'
                        }],


                        rec_door_num: [{
                            required: true,
                            message: '请输入门牌号',
                            trigger: 'blur'
                        }],


                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                        nick_name: [{
                            required: true,
                            message: '请输入用户昵称',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {

                this.userAllList();
                this.UserOpeninfoAllList();
                this.logisticsFareClass();
            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/activity/ActivityTurntableRecord/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/activity/ActivityTurntableRecord/edit', this.editForm).then(
                            res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的中奖记录吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/activity/ActivityTurntableRecord/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/activity/ActivityTurntableRecord/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 获取全部会员 */
                userAllList() {
                    this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.user_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/activity/ActivityTurntableRecord/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },

                //查询其他信息
                UserOpeninfoAllList() {
                    this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.user_openinfo_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                wuliu(row){
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/activity/ActivityTurntableRecord/wuliu',{out_pay_num:row.out_pay_num}).then(res => {
                        if (res.data.code === 0) {
                            loading.close();
                            this.wuliushowEdit = true;
                            setTimeout(() => {
                                this.wuliu_info = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                },
                deliverGoodsShow(row){
                    this.editFormfahuo.id = row.id;
                    this.fahuoShowEdit = true;
                },
                deliverGoods(){
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post("/activity/ActivityTurntableRecord/deliverGoods", this.editFormfahuo).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.fahuoShowEdit = false;
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            // row[name] = !row[name] ? 1 : 0;
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                },
                logisticsFareClass() {
                    this.$http.post('/logistics/LogisticsFareClass/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.logistics_fare_class = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                

            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>